import clsx from 'clsx';
import * as React from 'react';

import { Spinner } from '../Spinner';

const variants = {
  primary:
    'bg-primary text-white transition-all hover:bg-[#d96818] hover:opacity-100 disabled:bg-[#C6C6C6]',
  inverse: 'bg-white text-blue-600',
  danger: 'bg-red-600 text-white',
  secondary:
    'bg-[#CCCED1] text-gray-700 transition-all hover:bg-[#a8acb1] hover:text-gray-800 hover:opacity-100',
  text: 'bg-none text-blue-600',
  transparent: 'bg-white text-gray-700',
  /** Positive “add / create” actions (e.g. Thêm mới) */
  add:
    'bg-blue-500 text-white border-blue-500 hover:bg-blue-600 transition-all disabled:bg-[#C6C6C6] disabled:border-[#C6C6C6]',
  cancel:
    'bg-[#CCCED1] text-gray-700 transition-all hover:bg-[#a8acb1] hover:text-gray-800 hover:opacity-100',
  /** Neutral “refresh / sync” actions */
  refresh:
    'bg-blue-600 text-white border-blue-600 transition-all hover:bg-blue-700 hover:border-blue-700 active:bg-blue-800 active:border-blue-800 disabled:bg-[#C6C6C6] disabled:border-[#C6C6C6]',
  /** Positive “update” actions (e.g. Cập nhật) */
  update:
    'bg-green text-white border-green transition-all hover:bg-[#1b7a45] hover:border-[#1b7a45] active:bg-[#155f36] active:border-[#155f36] disabled:bg-[#C6C6C6] disabled:border-[#C6C6C6]',
  /** Destructive “delete” actions (e.g. Xóa) */
  delete:
    'bg-red text-white border-red-600 transition-all hover:bg-red-700 hover:border-red-800 disabled:bg-[#C6C6C6] disabled:border-[#C6C6C6]',
  // ✅ THÊM VARIANT MỚI: không border, background trắng
  'no-border': 'bg-white text-gray-700 border-none shadow-none'

};

const sizes = {
  sm: 'py-2 px-4 text-sm',
  md: 'py-2 px-2 text-md',
  lg: 'py-3 px-8 text-lg',
};

type IconProps =
  | { startIcon: React.ReactElement; endIcon?: never }
  | { endIcon: React.ReactElement; startIcon?: never }
  | { endIcon?: undefined; startIcon?: undefined };

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
  isLoading?: boolean;
  title?: string;
} & IconProps;

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      type = 'button',
      className = '',
      variant = 'primary',
      size = 'md',
      isLoading = false,
      startIcon,
      endIcon,
      title,
      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        className={clsx(
          'flex justify-center items-center border border-gray-300 disabled:cursor-not-allowed rounded-md shadow-sm font-medium',
          variants[variant],
          sizes[size],
          className,
        )}
        {...props}
        title={title}
      >
        {isLoading && <Spinner size="sm" className="text-current" />}
        {!isLoading && startIcon}
        <span className="mx-2">{props.children}</span> {!isLoading && endIcon}
      </button>
    );
  }
);

Button.displayName = 'Button';